import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.297 1.988a4.05 4.05 0 0 1 2.396.293.58.58 0 0 1 .171.937L9.685 5.396l.918.918 2.18-2.178.052-.047a.58.58 0 0 1 .884.218 4.052 4.052 0 0 1-4.98 5.509L5.004 13.55a1.807 1.807 0 1 1-2.555-2.555l3.733-3.734a4.05 4.05 0 0 1 .975-4.153 4.05 4.05 0 0 1 2.139-1.12M3.079 12.273a.65.65 0 0 0 1.107.459l4-4 .068-.058a.58.58 0 0 1 .58-.06 2.895 2.895 0 0 0 4.04-2.118c.05-.28.059-.564.027-.843L11.414 7.14a1.16 1.16 0 0 1-1.62 0l-.005-.004-.926-.926-.004-.005a1.157 1.157 0 0 1 0-1.62l1.488-1.488a2.9 2.9 0 0 0-2.37.829 2.89 2.89 0 0 0-.59 3.24c.099.219.052.476-.119.647l-4 4a.65.65 0 0 0-.189.459"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })